module.exports = __webpack_public_path__ + "static/conference-2d763dfb75396294a664890d9c8701c0.svg";